<template>
  <WarRemitWarrants />
</template>

<script>
import WarRemitWarrants from '../../../components/War/Utils/WarRemitWarrants.vue';

export default {
  name: 'WarrantsRemitWarrants',
  components: { WarRemitWarrants },
};
</script>
